import { authAPI } from "../config";

export const stt = (data: any) => {
  return authAPI.post(`/stt`, data);
};

export const tts = (data: any) => {
  return authAPI.post(`/tts`, data);
};

export const saveRecord = (file: any) => {
  return authAPI.post(`/stt-upload`, file);
};
